import Grid from '@mui/material/Grid'
import { InvoicePatternFields } from './InvoicePatternFields'
import { InvoiceSequenceFields } from './InvoiceSequenceFields'

export const InvoiceSequenceForm: React.FC<{}> = () => {
  return (
    <Grid container direction='row' spacing={1}>
      <InvoiceSequenceFields />
      <InvoicePatternFields />
    </Grid>
  )
}
